<!-- 周边搜索 -->
<template>
    <div class="search-around">
        <div class="header clearfix">
            <div class="left">
                <span class="back" @click="goback()">
                    <i class="iconfont icon-fanhui"></i>
                    <span>返回</span>
                </span>
                <span class="name">周边查询结果</span>
            </div>
            <div class="operation right" @click="contraction()">
                <i :class="aroundExpand ? 'iconfont icon-quanping' : 'iconfont icon-shouqi'"></i>
            </div>
        </div>
        <div style="height:calc(100% - 44px);" v-show="!aroundExpand">
            <div class="search clearfix">
                <div class="name left">周边</div>
                <div class="select left">
                    <el-select v-model="selectValue" placeholder="请选择">
                        <el-option
                                v-for="item in select"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="query left" @click="mapSearchAroundHandler">
                    查询
                </div>
            </div>
            <div class="around">
                <el-scrollbar style="height: 100%;width: 100%;">
                    <ul>
                      <el-empty v-show="this.totalCount===0" :image-size="200"></el-empty>
                        <li class="around-item" v-for="(item, index) in list" :key="'list'+index">
                            <div class="name clearfix" @click="aroundClick(index)">
                            <span class="left">
                                <i :class="aroundActive=== index? 'active el-icon-arrow-right around-el-icon': 'el-icon-arrow-right around-el-icon'"></i>
                                <i :class="'iconfont '+ item.icon"></i>
                                <span v-html="item.type"></span>
                            </span>
                                <span class="right">
                                <span v-html="item.resultList.length">5</span>
                            </span>
                            </div>
                            <ul v-show="aroundActive === index">
                                <li  @mouseover="mousemoveHandler(childrenIndex,true)" @mouseout="mousemoveHandler(childrenIndex,false)" class="children-item" v-for="(childrenItem, childrenIndex) in item.resultList" :key="'item'+index+childrenIndex">
                                    <div class="item-icon">
                                        <div>
                                            <i class="iconfont icon-dingweiqipao-"></i>
                                            <span v-html="childrenIndex+1"></span>
                                        </div>
                                    </div>
                                    <div class="data" v-html="childrenItem.name"></div>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>
<script>
import {mapsearcharound} from '@/views/class/mapsearcharound'
import {coordinatesconvert} from '@/views/class/coordinatesconvert'
import {mapmanager} from '@/views/class/mapmanager'

export default {
  data() {
    return {
      componentShow: 'mapSearchResultsList',
      selectValue: '500',
      aroundExpand: false,
      select: [{
        label: '500米',
        value: '500'
      }, {
        label: '800米',
        value: '800'
      }, {
        label: '1000米',
        value: '1000'
      }, {
        label: '2000米',
        value: '5000'
      }],
      list: [],
      aroundActive: -1,
      totalCount: 0,
      feature: ''
    }
  },
  watch: {
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    //
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    // todo
  },
  methods: {
    mapSearchAroundHandler() {
      this.mapSearchAround(this.feature)
    },
    mapSearchAround(feature) {
      this.feature = feature
      const latlng = mapmanager.getPolygonCenterPoint(feature)
      const distance = this.selectValue
      mapmanager.markerSelectedHandler(this.feature.index, false)
      mapmanager.searchAround(latlng, distance)
      const coords = coordinatesconvert.wgs84togcj02(Number(latlng[1]), Number(latlng[0]))
      mapsearcharound.analysisGaodeMapAround(distance, coords, this.queryCallBack)
    },
    queryCallBack(data) {
      this.totalCount = data.length
      this.list = data
      this.aroundClick(0)
      //
    },
    // 返回
    goback() {
      this.selectValue = 500
      this.aroundActive = -1
      this.$parent.resultExpand = false
      this.$emit('goback')
      mapmanager.markerSelectedHandler(this.feature.index, true)
      mapmanager.clearPoisLayers()
    },
    // 扩大缩小
    contraction() {
      this.aroundExpand = !this.aroundExpand
      this.$parent.resultExpand = !this.$parent.resultExpand
    },
    // 折叠面板
    aroundClick(index) {
      if (this.aroundActive === index) {
        this.aroundActive = -1
        mapmanager.map.poisLayerGroup.clearLayers()
      } else {
        this.aroundActive = index
        if (this.list && this.list.length > 0) {
          const item = this.list[index]
          const pois = item.resultList
          mapmanager.drawPois(pois)
        }
      }
    },
    mousemoveHandler(index, status) {
      mapmanager.poisMarkerMousemoveHandler(index + 1, status)
    }
  }
}
</script>
<style lang="scss" scoped>
    .search-around {
        height: 100%;
        width: 100%;
        .header{
            height: 44px;
            padding: 10px;
            border-bottom: 1px solid #dedede;
            .name{
                font-size: 16px;
                font-weight: bold;
                color: #333333;
                vertical-align: middle;
            }
            .back{
                height: 24px;
                background: #4293f4;
                border-radius: 4px;
                font-size: 14px;
                color: #ffffff;
                cursor: pointer;
                line-height: 24px;
                padding: 0px 8px;
                display: inline-block;
                margin-right: 10px;
                vertical-align: middle;
                i.iconfont{
                    font-size: 14px;
                }
            }
            .operation{
                line-height: 24px;
                cursor: pointer;
                i.iconfont{
                    font-size: 14px;
                }
            }
        }
        .search{
            height: 50px;
            padding: 9px 15px;
            line-height: 32px;
            font-size: 14px;
            color: #333333;
            .name{
                margin-right: 30px;
            }
            .select{
                width: calc(100% - 28px - 30px - 64px - 8px);
                .el-select{
                    width: 100%;
                    ::v-deep{
                        .el-input .el-input__inner{
                            line-height: 32px;
                            height: 32px;
                        }
                    }
                }
            }
            .query{
                margin-left: 8px;
                height: 32px;
                background: #2f80ed;
                border-radius: 4px;
                text-align: center;
                color: #fff;
                width: 64px;
                cursor: pointer;
            }
        }
        .around{
            text-align: left;
            height: calc(100% - 50px);
            color: #333333;
            .around-item{
                margin-bottom: 5px;
                padding: 0px 10px;
                .name{
                    height: 32px;
                    background: #f4f4f4;
                    line-height: 32px;
                    font-size: 14px;
                    padding: 0px 15px 0px 10px;
                    cursor: pointer;
                    .around-el-icon{
                        font-size: 16px;
                        transition: transform .3s;
                        &.active{
                            transform: rotate(90deg);
                        }
                    }
                    i.iconfont{
                        font-size: 14px;
                        color: #4293F4;
                        margin: 0px 5px 0px 6px;
                    }
                }
                .children-item{
                    height: 35px;
                    border-left: 5px solid transparent;
                    padding-left: 20px;
                    line-height: 35px;
                    font-size: 14px;
                    cursor: pointer;
                    position: relative;
                    .item-icon{
                        position: absolute;
                        left: 3px;
                        >div{
                            position: relative;
                            .iconfont{
                                color: #F54236;
                                font-size: 27px;
                            }
                            span{
                                position: absolute;
                                left: 50%;
                                transform: translateX(-50%);
                                font-size: 12px;
                                color: #ffffff;
                                margin-top: -3px;
                            }
                        }
                    }
                    .data{
                        position: absolute;
                        left: 35px;
                    }
                    &.active,&:hover {
                        background: rgba(66,147,244,0.10);
                        border-left: 5px solid #4293F4;
                        .item-icon{
                            >div{
                                .iconfont{
                                    color: #4293F4;
                                }
                            }
                        }
                    }
                }
            }
            ::v-deep{
                .el-scrollbar__wrap{
                    overflow-x: hidden;
                }
            }
        }
    }
</style>
